export default "__VITE_ASSET__BePn8UGi__"